import { defineMessages } from "react-intl";

export default defineMessages({
  addSocialProperties: {
    id: "accounts.PropertyTypes.addSocialProperties",
    defaultMessage: "Add Social Properties",
  },
});
